export default {
    twinEarlyPregnancy: 'Twin Early Pregnancy',
    indication: "indication",
    medicalAbbreviationTest: "medicalAbbreviationTest",
    medicalAbbreviationTestDate: "medicalAbbreviationTestDate",
    examinationMethod: "examinationMethod",
    examinationView: "examinationView",
    gestationalMedicalAbbreviationTest: "gestationalMedicalAbbreviationTest",
    gestationalMedicalAbbreviationTestWeek: "gestationalMedicalAbbreviationTestWeek",
    gestationalMedicalAbbreviationTestDay: "gestationalMedicalAbbreviationTestDay",
    gestationalSacType: "gestationalSacType",
    gestationalLocationType: "gestationalLocationType",
    aYolkSacType: "aYolkSacType",
    aEmbryoSonographicType: "aEmbryoSonographicType",
    aCRL: "aCRL",
    aCRLEquatWeek: "aCRLEquatWeek",
    aCRLEquatDay: "aCRLEquatDay",
    aCardiacActivity: "aCardiacActivity",
    bYolkSacType: "bYolkSacType",
    bEmbryoSonographicType: "bEmbryoSonographicType",
    bCRL: "bCRL",
    bCRLEquatWeek: "bCRLEquatWeek",
    bCRLEquatDay: "bCRLEquatDay",
    bCardiacActivity: "bCardiacActivity",
    uterusPosition: "uterusPosition",
    bothOvariesType: "bothOvariesType",
    pouchDouglasType: "pouchDouglasType",
    freeFluType: "freeFluType",
    impressionLocation: "impressionLocation",
    planAndFollowUpType: "planAndFollowUpType",
    finalDescription: "finalDescription"
}